module.exports = __webpack_public_path__ + "static/img/icon_star_normal@2x.9bc43e65.png";